import { Separator } from "ui/components/separator";

export const DetailItem = ({ label, children, showSeparator = true }) => (
  <>
    <div className="flex flex-col items-start gap-2 p-2 mb-2">
      <p className="text-sm font-medium text-muted-foreground">{label}</p>
      <div className="flex items-center gap-2">{children}</div>
    </div>
    {showSeparator && <Separator className="m-0" />}
  </>
);